<template>
  <div class="doc-container font-roboto-light top-border">
    <div class="container">
      <div class="row flex-xl-nowrap g-0">
        <SidebarDocumentation/>
        <!-- ****************************** DOC MAIN BODY ********************************* -->
        <main class="col-xl-9 col-md-8 doc-main-body">


          <h2>Local development</h2>
          <h3>What is local development?</h3>

          <p><span class="font-roboto-medium">Local development</span> allows you to develop the frontend locally and connect it to your backend in your AWS development account.</p>


          <h3>Set up your local frontend environment and start developing</h3>
          <ul class="list-item-one">
            <li>
              Run the following command to install frontend dependencies:
              <CodeContainer :code="npmInstallFrontend.code" :language="npmInstallFrontend.language"/>
            </li>
            <li class="mt-15">
              Create the following file in your <span class="font-roboto-medium">frontend</span> folder: <br>
              - <span class="font-roboto-medium">.env.development</span> <br>
            </li>
            <li class="mt-15">
              Open the environment variables settings in AWS Amplify within your AWS development account.
              <div class="documentation-image">
                <img
                    src="../../../../assets/images/documentation/development/amplify_envs.png"
                    alt=""
                    class="shapes screen-one"
                />
              </div>
            </li>
            <li class="mt-50">
              Copy them into the <span class="font-roboto-medium">.env.development</span> file. Here is an example:
              <CodeContainer :code="envs.code" :language="envs.language"/>
            </li>

            <li class="mt-15">
              Run the following command to start a local frontend server:
              <CodeContainer :code="npmRunDev.code" :language="npmRunDev.language"/>
            </li>
            <li class="mt-15">
              Open your browser and enter the following URL: <span class="font-roboto-medium">localhost:8080</span>
            </li>
            <li class="mt-15">
              You are now set up for local development! 🎉 Congrats!
            </li>
          </ul>


          <DocumentationPagination/>
        </main> <!-- /.doc-main-body -->
      </div>
    </div>
  </div>
</template>

<script>
import SidebarDocumentation from "@/components/service-documentation/commons/SidebarDocumentation.vue";
import DocumentationPagination from "@/components/service-documentation/commons/DocumentationPagination.vue";
import {ref} from "vue";
import CodeContainer from "@/components/service-documentation/commons/CodeContainer.vue";

export default {
  name: 'LocalDevelopment',
  components: {
    CodeContainer,
    SidebarDocumentation,
    DocumentationPagination,
  },
  setup() {

    const npmInstallFrontend = ref({
      language: 'bash',
      code:
          'cd frontend\n' +
          'npm install'
    });
    const npmRunDev = ref({
      language: 'bash',
      code:
          'cd frontend\n' +
          'npm run dev'
    });

    const envs = ref({
      language: 'bash',
      code: `# General settings for all branches
AMPLIFY_DIFF_DEPLOY=false
AMPLIFY_MONOREPO_APP_ROOT=frontend

# Development environment
VITE_APP_BACKEND_URL=https://paosidpas2.execute-api.us-west-1.amazonaws.com/
VITE_APP_REDIRECT_PATH=service
VITE_APP_CDK_ENV=dev
VITE_APP_AWS_PROJECT_REGION=us-west-1

# AWS Cognito settings
VITE_APP_AWS_COGNITO_IDENTITY_POOL_ID=us-west-1:lalskdjasidasd
VITE_APP_AWS_COGNITO_REGION=us-west-1
VITE_APP_AWS_USER_POOLS_ID=us-west-1_lkasjd
VITE_APP_AWS_USER_POOLS_WEB_CLIENT_ID=6cps26vub8rlkajsdla
VITE_APP_COGNITO_DOMAIN=saasconstructuserpool1234dev.auth.us-west-1.amazoncognito.com

# Payment system settings (either LEMON_SQUEEZY or Stripe)
VITE_APP_PAYMENT_SYSTEM=LEMON_SQUEEZY

# Subscription pricing for Stripe (if you have chosen LEMON_SQUEEZY don't change anything here)
VITE_APP_PRICE_IDS_FOR_SUBS_STRIPE=price_lkjasdlkjasd,price_lkajsdlkjsad,price_lkajslkj,price_1OvxBaJ6GW9pakwjlaksjd,price_1OvxIpJ6asdas,price_1OvxJalksdjalskd
VITE_APP_PRICES_FOR_SUBS_STRIPE=0,20,40,0,200,400

# Subscription pricing for Lemon Squeezy (if you have chosen STRIPE don't change anything here)
VITE_APP_LEMON_SQUEEZY_STORE_ID=81237
VITE_APP_PRICE_IDS_FOR_SUBS_LEMON_SQUEEZY=848484,23232,123123,123123,123123,123123
VITE_APP_PRICES_FOR_SUBS_LEMON_SQUEEZY=0,20,40,0,200,400`
    });

    return {
      npmInstallFrontend,
      envs,
      npmRunDev
    };
  }
}
</script>
